import React from 'react';
import { heroAreas, mockupUrl, offerAnchor } from '../data/content';
import { Button } from './ui/Button';
import { OfferLink } from './ui/OfferLink';
import { Mark } from './ui/Section';
export function Hero() {
  return <section className="bg-canvas px-4 pb-12 pt-8 md:pb-14 md:pt-10" data-id="element-89" data-mp="9ll9mylze0o1">
      <div className="mx-auto max-w-5xl text-center" data-id="element-90" data-mp="4m8n6ez0uvlz">
        <p className="font-display text-[11px] font-extrabold uppercase tracking-[.3em] text-brand md:text-xs" data-id="element-91" data-mp="4njng4t9dl8c">
          Bright Digital Hub
        </p>
        <h1 className="mx-auto mt-3 max-w-3xl font-display text-3xl font-black uppercase leading-[1] tracking-tight text-navy sm:text-4xl md:text-5xl" data-id="element-92" data-mp="xa4gd9pdu5e0">
          Complete <span className="text-brand" data-id="element-93" data-mp="sd4bv386lap0">Injury</span> Rehabilitation Bundle
        </h1>

        <OfferLink className="mx-auto my-5 max-w-[300px] sm:max-w-[400px]" label="See the Complete Injury Rehabilitation Bundle offer" data-id="element-94" data-mp="neaugzprwzjk">
          <img src={mockupUrl} alt="Complete Injury Rehabilitation Bundle: 5 complete volumes and 5 practical bonuses" className="w-full object-contain drop-shadow-2xl transition-transform duration-300 ease-out group-hover:scale-[1.015]" data-id="element-95" data-mp="381xmt2oj9aca" />
        </OfferLink>

        <p className="font-display text-sm font-black uppercase leading-tight text-navy md:text-lg" data-id="element-96" data-mp="39autvl4lu10x">
          <Mark data-id="element-97" data-mp="3e8mud3jbevgq">5 Complete Volumes + 5 Practical Bonuses</Mark>
        </p>
        <p className="mx-auto mt-4 max-w-2xl text-sm font-semibold leading-relaxed text-navy md:text-base" data-id="element-98" data-mp="30i19j9aawbg7">
          A practical exercise system for mobility, strengthening, stability and progressive return to training.
        </p>
        <p className="mx-auto mt-2 max-w-2xl text-sm leading-relaxed text-steel" data-id="element-99" data-mp="2qkwjuzh8xxun">
          Exercises organized by body area and level, with sets, reps, rest periods, regressions and progressions
          already included.
        </p>

        <ul className="mx-auto mt-6 flex max-w-3xl flex-wrap justify-center gap-2" aria-label="Main areas covered" data-id="element-100" data-mp="2hjym2yxeimki">
          {heroAreas.map(area => <li key={area} className="rounded-full bg-navy px-3.5 py-1.5 text-[11px] font-bold uppercase tracking-wide text-white" data-id="element-101" data-mp="s2b6puz5ad3k">
              {area}
            </li>)}
        </ul>

        <div className="mt-7" data-id="element-102" data-mp="ichz1524ii4l">
          <Button href={offerAnchor} size="lg" subtext="5 Volumes + 5 Practical Bonuses" data-id="element-103" data-mp="dd5eiqyq5n56">
            See the complete system
          </Button>
        </div>

      </div>
    </section>;
}